export default {
  title: "Starred",
  subtitle: "Your bookmarked items",
  comingSoon: "Coming Soon",
  description: "This feature will allow you to bookmark and quickly access important items.",
};
